import callApiBase from './base';

const cardReceivablesApi = {
  getPendencies: ({
    cardNumber,
    expirationDate,
    transportOperatorId,
  }: {
    cardNumber: string;
    expirationDate: string;
    transportOperatorId: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingList',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Get Pendencies',
      data: { cardNumber, expirationDate, transportOperatorId },
    }),

  generatePayment: ({
    transactionIds,
    transportOperatorId,
    transportOperatorName,
  }: {
    cardNumber: string;
    transactionIds: string[];
    transportOperatorId: string;
    transportOperatorName: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingPay',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Generate Payment',
      data: { ids: transactionIds, transportOperatorId, transportOperatorName },
    }),

  getHistory: ({
    cardNumber,
    expirationDate,
    transportOperatorId,
  }: {
    cardNumber: string;
    expirationDate: string;
    transportOperatorId: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingHistory',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Get History',
      data: { cardNumber, expirationDate, transportOperatorId },
    }),

  refreshPayment: ({
    paymentId,
    transportOperatorId,
  }: {
    paymentId: string;
    transportOperatorId: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingPaymentRefresh',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Refresh Payment',
      data: { paymentId, transportOperatorId },
    }),

  releasePayment: ({
    paymentId,
    transportOperatorId,
  }: {
    paymentId: string;
    transportOperatorId: string;
  }) =>
    callApiBase({
      endpoint: '/emvPendingPaymentRelease',
      method: 'POST',
      useToken: true,
      title: 'Card Receivables - Release Payment',
      data: { paymentId, transportOperatorId },
    }),
};

export { cardReceivablesApi };
export default cardReceivablesApi;
